import React, { useState } from "react";
import "./UserRoleForm.css";

const UserRoleForm = ({ onSubmit, user }) => {
  const [role, setRole] = useState("");
  const [customRole, setCustomRole] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedRole = role === "other" ? customRole : role;
    if (!selectedRole) {
      alert("Please select or enter your role.");
      return;
    }

    // Map roles to workspace IDs
    const roleToWorkspaceId = {
      'freelancer': 1,
      'student': 2,
      'content_creator': 3,
      'influencer': 4,
      'entrepreneur': 5
    };

    const workspaceId = roleToWorkspaceId[selectedRole] || null;

    // Navigate directly to the workspace based on role
    const workspaceRoutes = {
      'freelancer': '/FreelancerWorkSpace',
      'student': '/StudentWorkSpace',
      'content_creator': '/CreatorWorkSpace',
      'influencer': '/InfluencerWorkspace',
      'entrepreneur': '/EntrepreneurWorkSpace'
    };

    const route = workspaceRoutes[selectedRole];
    if (route) {
      // Store the workspace info for later use
      localStorage.setItem('userRole', selectedRole);
      localStorage.setItem('workspaceId', workspaceId);
      window.location.href = route; // Direct navigation
    } else {
      onSubmit({ role: selectedRole, workspaceId }); // fallback
    }
  };

  return (
    <div className="role-form-container">
      <h2 className="role-title">Tell us more about you</h2>
      <p className="role-subtitle">
        To set up your workspace, please choose what best describes you.
      </p>

      <form className="role-form" onSubmit={handleSubmit}>
        <div className="role-options">
          <label className={`role-card ${role === "freelancer" ? "selected" : ""}`}>
            <input
              type="radio"
              value="freelancer"
              checked={role === "freelancer"}
              onChange={(e) => setRole(e.target.value)}
            />
            <span>Freelancer</span>
          </label>

          <label className={`role-card ${role === "student" ? "selected" : ""}`}>
            <input
              type="radio"
              value="student"
              checked={role === "student"}
              onChange={(e) => setRole(e.target.value)}
            />
            <span>Student</span>
          </label>

          <label className={`role-card ${role === "content_creator" ? "selected" : ""}`}>
            <input
              type="radio"
              value="content_creator"
              checked={role === "content_creator"}
              onChange={(e) => setRole(e.target.value)}
            />
            <span>Content Creator</span>
          </label>

          <label className={`role-card ${role === "influencer" ? "selected" : ""}`}>
            <input
              type="radio"
              value="influencer"
              checked={role === "influencer"}
              onChange={(e) => setRole(e.target.value)}
            />
            <span>Influencer</span>
          </label>

          <label className={`role-card ${role === "entrepreneur" ? "selected" : ""}`}>
            <input
              type="radio"
              value="entrepreneur"
              checked={role === "entrepreneur"}
              onChange={(e) => setRole(e.target.value)}
            />
            <span>Entrepreneur</span>
          </label>

          <label className={`role-card ${role === "other" ? "selected" : ""}`}>
            <input
              type="radio"
              value="other"
              checked={role === "other"}
              onChange={(e) => setRole(e.target.value)}
            />
            <span>Other</span>
          </label>
        </div>

        {role === "other" && (
          <input
            type="text"
            className="custom-input"
            placeholder="Please specify your field..."
            value={customRole}
            onChange={(e) => setCustomRole(e.target.value)}
          />
        )}

        <button type="submit" className="role-submit">
          Continue to Workspace
        </button>
      </form>
    </div>
  );
};

export default UserRoleForm;
